import { Toast } from '@/components/Toast/Toast'
import { UrlPattern } from '@/utils/formValidation'
import { toast } from 'sonner'

const handleNavigation = (of: Toast) => {
  if (!of.url) return

  of.onClick?.()

  const isExternal = UrlPattern.test(of.url)

  if (isExternal) {
    window.open(of.url, '_blank')
  } else {
    window.location.href = of.url
  }
}

export const showToast = (of?: Toast) => {
  if (!of) return

  const description = of.dangerouslySetInnerHTML ? (
    <div dangerouslySetInnerHTML={of.dangerouslySetInnerHTML} />
  ) : (
    of.subtitle
  )

  const duration = of.requireInteraction ? Infinity : 5000

  const commonOptions = {
    description,
    duration,
  }

  if (of.type === 'success') {
    toast.success(of.title || '', {
      ...commonOptions,
      action: of.url
        ? {
            label: 'Open',
            onClick: () => handleNavigation(of),
          }
        : undefined,
      onAutoClose: () => {
        if (of.url) handleNavigation(of)
      },
    })
  }

  if (of.type === 'danger') {
    toast.error(of.title || '', {
      ...commonOptions,
      action: of.url
        ? {
            label: 'Open',
            onClick: () => handleNavigation(of),
          }
        : undefined,
      onAutoClose: () => {
        if (of.url) handleNavigation(of)
      },
    })
  }

  if (of.type === 'warning') {
    toast.warning(of.title || '', {
      ...commonOptions,
      action: of.url
        ? {
            label: 'Open',
            onClick: () => handleNavigation(of),
          }
        : undefined,
      onAutoClose: () => {
        if (of.url) handleNavigation(of)
      },
    })
  }
}
